import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/';
import Solicitacao from '../components/solicitacao';




const mapStateToProps = (state, ownProps) => {

    return state.solicitacao;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onFinalizar: (e) => {
            dispatch(actions.onFinalizar());
        },

        onNextStep: (e) => {
            dispatch(actions.nextStep());
        },

        onBackStep: (e) => {
            dispatch(actions.backStep());
        },
        onChangeIsAlteracao: (e, index) => {
            dispatch(actions.onChangeIsAlteracao(index === 1))
        },

        changeCampoGenericoAlteracao: (campoState, valor) => {
            dispatch(actions.changeCampoGenericoAlteracao(campoState, valor))
        },
        
        getDadosParaAlteracao:() => {
            dispatch(actions.getDadosParaAlteracao());
        }

    };
};

const SolicitacaoContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Solicitacao);


export default SolicitacaoContainer;


// WEBPACK FOOTER //
// ./src/containers/solicitacao.js